/**
 * 請求書記載情報の、項目の鍵と画面に出す名前。
 *
 * ## なぜ1か所に置くのか
 *
 * 同じ項目の名前が、3か所に出る。
 *
 * - 自社設定の一覧のカード（いま入っている値）
 * - 自社設定の編集画面（入力欄）
 * - 請求書管理の案内（まだ空の項目）
 *
 * 別々に書くと、片方だけ言い換えたときに「請求書管理で言われた項目が、
 * 自社設定のどの欄か分からない」ことになる。
 *
 * ## 鍵はサーバと同じ名前
 *
 * `key` は、サーバへ送る鍵で、サーバが返す項目の名前でもある
 * （InvoiceIssuerSettingService の KEY_*）。片方だけ変えると、保存したのに
 * 届かない・触っていない項目が消える、のどちらかになる。
 *
 * ## 上限の文字数
 *
 * サーバと同じ数。本番の列の長さで決まっている。超えた値はサーバが断る
 * （切らない）ので、入力欄でも同じ数で止める。
 */

/** 文字で入れる5項目。**保存のときは5つとも送る。** */
export const INVOICE_ISSUER_TEXT_FIELDS = Object.freeze([
  { key: 'address', label: '住所', maxLength: 60, placeholder: '' },
  { key: 'building', label: '建物名', maxLength: 60, placeholder: '' },
  { key: 'invoice_registration_no', label: 'インボイス登録番号', maxLength: 20, placeholder: 'T1234567890123' },
  { key: 'billing_contact', label: '請求担当者', maxLength: 20, placeholder: '' },
  { key: 'bank_name', label: '振込先', maxLength: 100, placeholder: '○○銀行 ○○支店 普通 1234567 カ）…' }
])

/** 角印の欄の名前。 */
export const INVOICE_ISSUER_SEAL_LABEL = '角印'

/** 鍵から、画面に出す名前を引く。知らない鍵は鍵のまま返す。 */
export function invoiceIssuerLabel (key) {
  const field = INVOICE_ISSUER_TEXT_FIELDS.find(one => one.key === key)
  return field ? field.label : String(key || '')
}

/**
 * サーバが返した値から、入力欄の初期値を作る。
 * **5つの鍵を必ず持つ**（無い値は空文字）。保存のとき1つでも欠けるとサーバが断る。
 */
export function invoiceIssuerFormFrom (data) {
  const form = {}
  INVOICE_ISSUER_TEXT_FIELDS.forEach(field => {
    const value = data ? data[field.key] : ''
    form[field.key] = value === null || value === undefined ? '' : String(value)
  })
  return form
}
